const en: Record<string, string> = {
  'features.groceries.empty': 'No grocery lists yet. Schedule one to get started.',
  'features.groceries.newList': 'New list',
  'features.groceries.listName': 'Name',
  'features.groceries.listNamePlaceholder': 'e.g. Weekly shop',
  'features.groceries.scheduledDate': 'Scheduled date',
  'features.groceries.noScheduledDate': 'No date yet',
  'features.groceries.assignedTo': 'Assigned to',
  'features.groceries.noAssignee': 'No one yet',
  'features.groceries.forceOnDashboard': 'Always show on dashboard',
  'features.groceries.cancel': 'Cancel',
  'features.groceries.create': 'Create',
  'features.groceries.planned': 'Planned',
  'features.groceries.done': 'Done',
  'features.groceries.passed': 'Passed',
  'features.groceries.editList': 'Edit list',
  'features.groceries.defaultListTitle': 'Next shopping',
  'features.groceries.remainingCount': '{{count}} of {{total}} items left to pick up',
  'features.groceries.noItems': 'No items yet.',
  'features.groceries.showPickedUpItems': 'Show picked up items',
  'features.groceries.hidePickedUpItems': 'Hide picked up items',
  'features.groceries.allPickedUpHidden': 'Every item is picked up and hidden. Show them again from the tab menu.',
  'features.groceries.editItems': 'Edit items',
  'features.groceries.viewCatalog': 'Catalog',
  'features.groceries.backToLists': 'Back to lists',
  'features.groceries.backToList': 'Back to groceries',
  'features.groceries.shoppingMode': 'Shopping mode',
  'features.groceries.configureSections': 'Configure sections',
  'features.groceries.doneConfiguringSections': 'Done configuring sections',
  'features.groceries.markFavorite': 'Mark as favorite',
  'features.groceries.unmarkFavorite': 'Remove from favorites',
  'features.groceries.archiveList': 'Archive list',
  'features.groceries.restoreList': 'Restore list',
  'features.groceries.showArchivedLists': 'Show archived ({{count}})',
  'features.groceries.hideArchivedLists': 'Hide archived',
  'features.groceries.copyFromFavorite': 'Start from a favorite list',
  'features.groceries.copyFromFavoriteNone': "Don't copy items",
  'features.groceries.mealSuggestionsTitle': 'Suggested from upcoming meals',
  'features.groceries.addFromMeals': 'Add from meals',
  'features.groceries.noMealSuggestions': 'No meal suggestions right now.',
  'features.groceries.showCatalog': 'Show catalog',
  'features.groceries.hideCatalog': 'Hide catalog',
  'features.groceries.mealsAccountedFor': 'Meals accounted for in this list',
  'features.groceries.mealAccountedForHeadcount': '{{count}}p.',
  'features.groceries.mealSuggestionSubtitle': '{{recipe}} — {{meal}}, {{date}}, {{count}} persons',
  'features.groceries.addAllSuggestion': 'Add all',
  'features.groceries.addAccompanimentSuggestion': 'Add',
  'features.groceries.accompaniments': 'Accompaniments',
  'features.groceries.removeAddedMeal': 'Remove from this list',
  'features.groceries.removeAddedMealConfirm': 'Remove "{{recipe}}" ({{date}}) from this list? Items already added stay on your list — only the meal stops being accounted for.',
  'features.groceries.catalog': 'Catalog',
  'features.groceries.catalogEmpty': 'No catalog items yet. Add a section, then an item.',
  'features.groceries.filterItemsPlaceholder': 'Filter items…',
  'features.groceries.filterNoResults': 'No items match your filter.',
  'features.groceries.myList': 'My list',
  'features.groceries.uncategorized': 'Uncategorized',
  'features.groceries.addSection': 'Add section',
  'features.groceries.sectionName': 'Section name',
  'features.groceries.sectionNamePlaceholder': 'e.g. Butchery',
  'features.groceries.isFoodSection': 'Food section',
  'features.groceries.isFoodSectionHelp': 'Shown when picking ingredients for a recipe.',
  'features.groceries.isCondimentSection': 'Condiment section',
  'features.groceries.isCondimentSectionHelp': 'Ingredients from this section show apart, next to the recipe.',
  'features.groceries.addItemToSection': 'Add an item to this section',
  'features.groceries.addingToSection': 'Adding to:',
  'features.groceries.renameSection': 'Rename section',
  'features.groceries.moveSectionUp': 'Move section up',
  'features.groceries.moveSectionDown': 'Move section down',
  'features.groceries.deleteSection': 'Delete section',
  'features.groceries.deleteSectionMessage': 'Delete section "{{name}}"?',
  'features.groceries.save': 'Save',
  'features.groceries.manageItem': 'Edit item',
  'features.groceries.suggestions': "You're due to restock",
  'features.groceries.archiveItem': 'Archive item',
  'features.groceries.iconLabel': 'Icon',
  'features.groceries.sectionsLabel': 'Sections',
  'features.groceries.noSectionsYet': 'No sections yet.',
  'features.groceries.newItem': 'New item',
  'features.groceries.newItemName': 'New item name',
  'features.groceries.newItemNamePlaceholder': 'e.g. Tomatoes',
  'features.groceries.unitLabel': 'Unit',
  'features.groceries.unit.gram': 'Gram',
  'features.groceries.unit.gram_other': 'Grams',
  'features.groceries.unit.kg': 'Kg',
  'features.groceries.unit.kg_other': 'Kg',
  'features.groceries.unit.piece': 'Piece',
  'features.groceries.unit.piece_other': 'Pieces',
  'features.groceries.unit.liter': 'Liter',
  'features.groceries.unit.liter_other': 'Liters',
  'features.groceries.unit.none': 'None',
  'features.groceries.unit.none_other': 'None',
  'features.groceries.isDivisible': 'Can be split into fractional quantities',
  'features.groceries.renewalDays': 'Restock frequency (days)',
  'features.groceries.renewalDaysHelp': 'How often you typically restock this — used to suggest it again on future lists.',
  'features.groceries.renewalDaysPlaceholder': 'Not tracked',
  'features.groceries.suggestedQuantity': 'Suggested quantity',
  'features.groceries.suggestedQuantityHelp': 'Pre-fills the quantity when you add this item to a list.',
  'features.groceries.suggestedQuantityPlaceholder': 'Not set',
  'features.groceries.itemComment': 'Comment',
  'features.groceries.itemCommentPlaceholder': 'Add a note for this item…',
  'features.groceries.addCustomItem': 'Add a one-off item',
  'features.groceries.customItemName': 'Item name',
  'features.groceries.customItemNamePlaceholder': 'e.g. Trash bags',
  'features.groceries.customItemUnit': 'Unit (optional)',
  'features.groceries.customItemUnitPlaceholder': 'e.g. rolls',
};

export default en;
